import React, {useEffect} from "react";
import {Container} from "react-bootstrap";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {useDispatch, useSelector} from "react-redux";
import {Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import ModalShoppingCard from "../../../partials/modals/shoppingCard/ModalShoppingCard";
import ModalProduct from "../../../partials/modals/modalProduct/ModalProduct";
import ModalSelectBaseMarket from "../../../partials/modals/markets/ModalSelectBaseMarket";
import ModalGratuity from "../../../partials/modals/gratuity/ModalGratuity";
import ModalAddDiscountCode from "../../../partials/modals/modalAddDiscountCode";
import PageSearch from "./search/PageSearch";
import MoreProducts from "./moreProducts/MoreProducts";
import PageStoreScreen from "./PageStoreScreen";
import {actionRefreshModalShoppingCard} from "../../../../../redux/actions/modals/modalShoppingCard";
import LoaderPage from "../../../partials/loaders/LoaderPage";
import _ from "lodash";
import {actionChangeDataShoppingCart} from "../../../../../redux/actions/shoppingCart";
import {PUBLIC_URL_SERVER} from "../../../../../apis";

const Store = () => {
    const match = useRouteMatch();
    const dispatch = useDispatch();
    const history = useHistory();
    const {carts, storeSelected} = useSelector(state => state.shoppingCart);
    const {main, loader_main} = useSelector(state => state.main);

    useEffect(() => {
        if (match.params.store) {
            if (carts.length > 0 && storeSelected && storeSelected.id !== match.params.store) {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                        cancelButton: 'base-btn-green-border btn btn-success',
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
                    imageUrl: PUBLIC_URL_SERVER + 'icons/fm_logo_ofoghi_new.png',
                    imageHeight: 45,
                    imageAlt: 'فروت مروت',
                    confirmButtonText: "بله",
                    showCancelButton: true,
                    cancelButtonText: 'انصراف',
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleGetDataSelectedStore(match.params.store);
                        dispatch(actionRefreshModalShoppingCard());
                    }
                    else
                        history.push(`/stores/${storeSelected.id}`);
                });
                // swal({
                //     title: "توجه",
                //     text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
                //     buttons: {
                //         cancel: "انصراف",
                //         confirm: {
                //             text: 'بله',
                //             value: "ok",
                //         },
                //     },
                //     icon: "warning",
                // }).then((value) => {
                //     if (value === 'ok') {
                //         handleGetDataSelectedStore(match.params.store);
                //         dispatch(actionRefreshModalShoppingCard());
                //     } else {
                //         history.push(`/stores/${storeSelected.id}`);
                //     }
                // });
            } else {
                handleGetDataSelectedStore(match.params.store);
            }
        }
        // eslint-disable-next-line
    }, [match.params.store]);

    const {list_stores} = useSelector(state => state.stores);

    useEffect(() => {
        if (list_stores.length > 0) {
            const findStore = _.find(list_stores, item => item.id === match.params.store);
            if (!storeSelected || (storeSelected && storeSelected.id !== findStore)) {
                dispatch(actionChangeDataShoppingCart('storeSelected', findStore));
            }
        }
        // eslint-disable-next-line
    }, [list_stores]);

    useEffect(() => {
        if (main && main.main_messages && main.main_messages.length > 0) {
            main.main_messages.forEach(MItem => {
                swal({text: MItem.message, buttons: {cancel: "فهمیدم"}, icon: "warning"});
            });
        }
        // eslint-disable-next-line
    }, [main.main_messages]);

    const handleGetDataSelectedStore = (id) => {
        dispatch({type: "FETCH_MAIN_STORE", payload: {store: id}});
    }

    return !loader_main ? (
        <React.Fragment>
            <div>
                <ModalShoppingCard/>
                <ModalProduct/>
                <ModalSelectBaseMarket/>
                <ModalGratuity/>
                <ModalAddDiscountCode/>
            </div>
            <Container fluid={true} id={'cm-container'}>
                <div id={'base-main'}>
                    <Switch>
                        <Route exact path={match.path}><PageStoreScreen/></Route>
                        <Route exact path={`${match.path}/more-products/:category`}><MoreProducts/></Route>
                        <Route exact path={`${match.path}/search`}><PageSearch/></Route>
                        <Route path="/*"><PageStoreScreen/></Route>
                    </Switch>
                </div>
            </Container>
        </React.Fragment>
    ) : <LoaderPage/>;
}
export default Store;
